import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataRecord } from '../utils/DataRecord';

export class StepRecord extends StepBase
{
    logicRef    : LogicEngine;
    record      : DataRecord | undefined;
    tableName   : string = "";

    constructor(rawData :PageStepType, logic : LogicEngine)
    {
        super(rawData);
        this.logicRef = logic;
    }

}

